import gql from 'graphql-tag';
import { fullMatchUpdateFragment } from '../fragments/match';
export const matchSubscription = gql `
  subscription matchSub($matchSubscriptionArgs: MatchSubscriptionArgs!) {
    matchSubscription(matchSubscriptionArgs: $matchSubscriptionArgs) {
      updated
      match {
        ...FullMatchUpdate
      }
    }
  }
  ${fullMatchUpdateFragment}
`;
//# sourceMappingURL=match.js.map